module.exports = __webpack_public_path__ + "img/second-onboarding-bg.5b616b2c.svg";